import SenjaTweets from '@/components/app/SenjaTweets';
import { Button } from '@/components/app/ui/button';
import signInWithGoogle from '@/components/auth/signInWithGoogle';
import CodeDisplay, { CodeDisplaySimple } from '@/components/ui/CodeDisplay';
import Testimonials from '@/components/ui/Testimonials';
import CompaniesCarousel from '@/components/v2/CompaniesCarousel';
import BentoFeatures from '@/components/v4/BentoFeatures';
import CTAButtons from '@/components/v4/CTAButtons';
import ValueProps from '@/components/v4/ValueProps';
import { mendableInitialConversation } from '@/lib/mendable_initial_conv';
import { calLink } from '@/utils/constants';
import { Menu } from '@headlessui/react';
import { MendableChatBubble, MendableInPlace } from '@mendable/search';
import React, { useEffect } from 'react';
import { VscWorkspaceTrusted } from 'react-icons/vsc';
import ValuePropsComponent from '@/components/v4/ValueProps';
import UseCase from '@/lib/interface';
import CustomerTestimonials from './CustomerTestimonials';
import { NextSeo } from 'next-seo';
import ToolsHero from '../tools/ToolsHero';

export default function UseCaseLayout({ useCase }: { useCase: UseCase }) {
  const chatBubbleCode = `
import { MendableChatBubble } from '@mendable/search'

<MendableChatBubble 
    anon_key={MENDABLE_ANON_KEY} />
`;
  const saveChatHistoryToLocal = (chatHistory: any) => {
    const key = 'mendableBotChatHistorymendable';
    const chatHistoryJSON = JSON.stringify(chatHistory);
    localStorage.setItem(key, chatHistoryJSON);
  };
  const saveConversationId = (conversation: any) => {
    const key = 'mendableBotConversationIdmendable';
    const conversationJSON = JSON.stringify(conversation);
    localStorage.setItem(key, conversationJSON);
  };

  useEffect(() => {
    const key = 'mendableBotChatHistorymendable';
    saveChatHistoryToLocal(mendableInitialConversation);
    saveConversationId({ conversation_id: 1919191919 });
  }, []);


  
  return (
    <div>
      <NextSeo
        title={useCase.title}
        description={useCase.description}
        openGraph={{
          title: useCase.title,
          description: useCase.description,
        }}
      />
    <section className="lg:mt-36 w-full h-full min-h-screen">
      <div className="w-full flex flex-col items-start justify-start mt-10 lg:mt-20 max-w-7xl mx-auto px-8 sm:px-10">
        <div className="lg:h-[625px] flex flex-col w-full lg:flex-row items-start justify-between">
          <div className="mt-28 lg:w-2/3 flex flex-col items-start justify-start lg:pr-12">
            <a
              className=" bg-gray-800 bg-opacity-75 flex px-3 py-2 rounded-xl items-center"
              href={useCase.companyHighlight.link}
            >
              <span className="  text-sm ">
                {useCase.companyHighlight.title}
              </span>
            </a>
            <h1 className="text-white mt-10 font-bold  text-4xl sm:text-6xl text-start">
              {useCase.cta}
            </h1>
            <p className="text-white my-4 max-w-lg sm:text-lg text-start">
              {useCase.description}
            </p>

            <CTAButtons />
            <div className="my-4 flex items-center justify-center">
              {/* <Rating /> */}
              <VscWorkspaceTrusted />
              <h2 className="text-gray-200 ml-2">
                Over 1,000,000 customers answered
              </h2>
            </div>
          </div>
          {useCase.ctaComponent ? useCase.ctaComponent : <div className="  w-fit relative flex items-center justify-center ">
        <span className="spananim" />
        <div
          style={{}}
          className="relative h-full bg-gradient-to-br animate-text from-black via-black to-primary rounded-lg z-10 min-w-[305px] max-w-[305px] md:min-w-[350px] md:max-w-[350px] lg:min-w-[415px] lg:max-w-[415px] "
        >
          <MendableInPlace
            anon_key="88481495-0e21-49cc-96e5-c1783deb012b"
            showSimpleSearch={false}
            style={{
              accentColor: '#8559F4',
              darkMode: true,
              backgroundColor: '#00000000'
            }}
            messageSettings={{
              prettySources: true,
              persistMessagesBetweenSessions: true,
              scrollToView: true,
              openInNewTabForOutsideSources: true
            }}
          />
        </div>
      </div>}

          {/* <p className='text-gray-500 text-xl mt-8'>Some cool text here highlighitng more shit</p> */}
          {/* <MendableChatBubble style={{
            darkMode: false,
            accentColor: "#8559F4",
        }} anon_key="88481495-0e21-49cc-96e5-c1783deb012b" /> */}
        </div>
        <ValuePropsComponent valueProps={useCase.valueProps} />
        <div className='hidden sm:flex self-center -mb-10 mt-10'>
        <CustomerTestimonials />
        </div>
        <ToolsHero className='mx-auto ' />
        <BentoFeatures />
        <div className="overflow-hidden hidden lg:flex">
          <CompaniesCarousel />
        </div>
      </div>

      <div className="my-10 h-1" />

      <SenjaTweets />
    </section>
    </div>

  );
}
